import React ,{useRef ,useEffect ,useState}from 'react';
import SecurityService from '../security/security.service';
import moment from 'moment'

import DynamicInputList from '../software-dynamic-version-2/list-input-v-2';
import DialogInput from '../software-dynamic-version-2/popup-dialog-input-v-2';


import ProductAdd  from './product-add'
import ProductService from './product.service';
import AuditTable from '../audit-table/audit-table';
import './product.scss'
import securityService from '../security/security.service';



const ProductInput = (props) => {
    // let handleCheckboxChange = (e,props)=>{
    //   console.log(e)
    //   ProductService.delete(props.UserID).then(async (res)=>{
    //     document.getElementById(`checkbox_${props.UserID}`).checked =false
    //     await  showDialog('ALERT' ,<span class="error-success">User Actived</span>)
    //       // await getListService()
    //       })
    // }
  
    let columns = [
      { field: "ProductID", headerText: 'Product ID', width: '100px', textAlign: 'right', headerTextAlign: 'center', other: [] },
      { field: "ProductName", headerText: 'Product Name', width: '150px', textAlign: 'left', headerTextAlign: 'center', other: [] },
      { field: "ProductCategoryName", headerText: 'Product Category', width: '150px', textAlign: 'left', headerTextAlign: 'center', other: [] },
      { field: "OpeningQuantity", headerText: 'Opening Quantity', width: '150px', textAlign: 'right', headerTextAlign: 'center', other: [{format:'n2'}] },
      { field: "OpeningRate", headerText: 'Opening Rate (AED)', width: '150px', textAlign: 'right', headerTextAlign: 'center', other: [{format:'n2'}] },
      { field: "OpeningAmount", headerText: 'Opening Amount (AED)', width: '170px', textAlign: 'right', headerTextAlign: 'center', other: [{format:'n2'}] },
      { field: "AccountTitle", headerText: 'Expense Account', width: '180px', textAlign: 'left', headerTextAlign: 'center', other: [] },
    ];
    

        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
          console.log(getListService )
          console.log(selectedRow )
    
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            ProductID: args.data.ProductID,
            CompanyID: securityService.getCompanyIDLoggedInUserId(),
            ProductName: args.data.ProductName,
            ProductCategoryID: args.data.ProductCategoryID,
            OpeningQuantity: args.data.OpeningQuantity,
            OpeningRate: args.data.OpeningRate,
            OpeningAmount: args.data.OpeningAmount,
            AccountIDExpense: args.data.AccountIDExpense
        }
    
          console.log(data)
        if(args.action == 'add'){
          ProductService.insert(data).then(async (res)=>{
            await getListService()
            // inputName ,tableName,tableID,values
            // addUserLog('Product'  ,'Product',selectedRow,{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        if(args.action == 'edit'){
          ProductService.update(data).then((res)=>{
            getListService()
            // tableName,tableIDValue,selectedRows,values
            // editUserLog('Product',args.data.UserID,'UserID',{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = true
    let  allowDataBound = true
    let  allowGridSum = true
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Product${typeMode} 
        let ListSecurity='Product'
        let AddSecurity='Product'
        let EditSecurity='Product'
        let DeleteSecurity='Product'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      // let toolbarOptions ='All';
      let toolbarOptions =['Add','Edit', 'Delete' ,'Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
          

        //   const dialogRef = useRef(null);
        //   const showDialog = (header,title,actions =['OK']) => {
        //     return new Promise((resolve) => {
        //     // Destroy existing dialog if any
        //     if (dialogRef.current) {
        //       dialogRef.current.destroy();
        //     }
        //     const okButtons = actions.map((action) => ({
        //       buttonModel: {
        //         content: action,
        //         cssClass: 'e-flat',
        //         isPrimary: action === 'OK',
        //       },
        //       click: (e) => {
        //         hideDialog();
        //         resolve(action);
        //       },
        //     }));
        //     // Create a new dialog instance
        //     dialogRef.current = new DialogInput({
        //       content: ()=>(<>{title}</>),
        //       header:header,
        //       width:'340px',
        //       showButtons: true,
        //       buttons:okButtons
        //     });
        //     // Show the dialog programmatically
        //     dialogRef.current.show();

        //   });

        //   };
        // const hideDialog = () =>{
        //   if (dialogRef.current) {
        //   }
        //   dialogRef.current.hide();
        //   dialogRef.current.destroy();
        //   dialogRef.current = null; // Clean up reference after destruction
        // }

      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(grid , args)
        console.log(selectedRow)
      //   if(props.Active ==  false  ){
      //      if(args.name == "rowSelected" || args.name == "rowDeselected"){
      //     if(args.target?.type ==  'checkbox'){
      //   setTimeout( async () => {
          
      //     await getListService()
      //   }, 1500);
      // }
      // }
    
      // }
      //   if(args?.item?.properties?.id == 'IsActive'){
      //     if(selectedRow == undefined){
      //   await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      // }else{
      //   let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
      //   console.log(dialogResult)
      // if(dialogResult == 'OK'){
      //   ProductService.delete(selectedRow.UserID).then(async (res)=>{
      //   await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
      //     await getListService()
      //       AuditTable.auditDelete('Product',selectedRow.UserID,{
      //         UserName:selectedRow.UserName,
      //         FullName:selectedRow.FullName,
      //       })
      //     })
      //   }
      //   }
      //   }
        
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Product' ,
                    TableID:'ProductID',
                   // Optional if Delete is Soft // TableSecurity:'ProductDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Product' ,TableID:'ProductID', Optional // TableSecurity:'ProductDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
    //  let filterColumns = [{ field: 'IsActive', value: props?.Active == false ? 'No' : 'Yes' }];
     let filterColumns = [];
      

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = ['OpeningQuantity','OpeningRate','OpeningAmount'];


    return (
      
        <DynamicInputList
        Id='Product'
        ListTitle='Product - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> ProductService.getProductForList(securityService.getCompanyIDLoggedInUserId())
                        }]}
        DefaultSortedColumnName={'ProductID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<ProductAdd GridID={'Product'} CompanyID={securityService.getCompanyIDLoggedInUserId()} />
        
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            AllowGrouping={allowGrouping}
            AllowExcelExport={allowExcelExport}
            AllowPdfExport={allowPdfExport} 
            ShowColumnChooser={showColumnChooser}
            AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            GroupColumns={groupColumns} 
            // ListDelete={listDelete}
             DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>

            );
}



export default ProductInput;
